// extracted by mini-css-extract-plugin
export default {"entire-container":"Unauthorized_entire-container__lya3h","text-btn-container":"Unauthorized_text-btn-container__9VicN"};